import React from "react";
import {TableHeader} from "../../../components/table/CustomTable";


export default function DynamicItemTableHeader({count = 4}) {
  return (
    <thead>
    <tr>
      <TableHeaderItem extClass='w-6'>Move</TableHeaderItem>
      <TableHeaderItem extClass="pl-0">UI Element</TableHeaderItem>
    </tr>
    </thead>
  );
}

function TableHeaderItem({children,extClass, ...props}){
  return (
    <TableHeader {...props}
      className={`${extClass ? `${extClass} ` : ''}`}>
      {children}
    </TableHeader>
  );
}




